import React, { useState, useEffect } from "react";

import useMobileBreakpoint from "@src/hooks/useMobileBreakpoint";
import { Paragraph } from "@project-stories/elements/Paragraph/Paragraph";
import { Pagination } from "@project-stories/elements/Pagination/Pagination";
import { BlogArticleTile } from "@project-stories/blog/BlogArticleTile/BlogArticleTile";
import { Headings } from "@arctheme-components/elements/Headings/Headings";

const GridLayout = ({ initialArticles, settings }) => {
  const { section, blocks, globals } = settings;
  const articleBlocks = blocks?.filter((block) => block.type === "article_block");
  const isMobile = useMobileBreakpoint(globals.mobile_breakpoint);
  const [currentPage, setCurrentPage] = useState(1);
    const articlesPerPage = isMobile ? globals.articles_per_page_mobile : globals.articles_per_page
  const [articles, setArticles] = useState(articleBlocks || initialArticles || []);
  const [currentArticles, setCurrentArticles] = useState(
    articleBlocks?.slice(0, articlesPerPage) || initialArticles?.slice(0, articlesPerPage) || [],
  );


  const { section: { blog_type } } = settings;

  const showPagination = section.show_pagination !== false;

  // Reload articles when initialArticles changes (e.g., due to filtering)
  useEffect(() => {
    setArticles(initialArticles || []);
    setCurrentPage(1);
  }, [initialArticles]);

  useEffect(() => {
    const indexOfLastArticle = currentPage * articlesPerPage;
    const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
    const newArticles = articles.slice(indexOfFirstArticle, indexOfLastArticle);
    setCurrentArticles(newArticles);
  }, [currentPage, articles, articlesPerPage]);


  return (
    <div className={`w-full color-${section.color_schema}`}>
      <div
        className="blog-articles flex flex-col"
        x-data="pagination"
        x-init={`init(${articles.length}, ${articlesPerPage}, true, 'articles')`}
      >
        {currentArticles.length > 0 && (
          <>
            <div className="article-items">
              <div className={`grid transition-opacity duration-500 ease-in-out gap-x-4 lg:gap-x-5 ${blog_type == 'stories' ? 'blog-articles__grid-stories' : 'blog-articles__grid-default'}`}>
                {currentArticles.map((article, index) => {
              
                  const isFullWidth = article.metafields?.featured_media?.url && blog_type === 'stories';

                  return (
                    <div
                      className={`blog-articles__grid article transition-opacity duration-500 ease-in-out ${
                        isFullWidth 
                          ? "col-span-1 lg:col-span-3" 
                          : "col-span-1"
                      }`}
                      key={index}
                    >
                      {isFullWidth ? (
                        <div className="transition-opacity duration-500 ease-in-out">
                          <BlogArticleTile
                            article={article.article || article}
                            settings={settings}
                            type={blog_type}
                          />
                        </div>
                      ) : (
                        <div className={index === 0 || (index > 0 && isFullWidth) ? "" : ""}>
                          <BlogArticleTile
                            article={article.article || article}
                            settings={settings}
                            type={blog_type}
                          />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
            
            {showPagination && (
              <div className="flex justify-center items-center pt-[64px] lg:pt-[87px]">
                <Pagination 
                  currentPage={currentPage}
                  totalArticles={articles.length}
                  articlesPerPage={articlesPerPage}
                  onPageChange={(page) => setCurrentPage(page)}
                  isMobile={isMobile}
                />
              </div>
            )}
          </>
        )}
        {currentArticles.length <= 0 && (
          <div className={"blog-articles-empty"}>
            <Paragraph
              text={"There are no articles found with that filter."}
              type={"b2"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default GridLayout;
